"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOTPSetup = void 0;
var React = require("react");
var QRCode = require("qrcode.react");
var react_intl_1 = require("react-intl");
var react_final_form_1 = require("react-final-form");
var Validators_1 = require("../utils/Validators");
var chainAuthErrorMapping_1 = require("../utils/chainAuthErrorMapping");
function TOTPSetup(_a) {
    var additionalData = _a.additionalData, onVerifyTOTPSetup = _a.onVerifyTOTPSetup, Components = _a.Components;
    if (!additionalData || !additionalData.link || !additionalData.secret) {
        return null;
    }
    return (React.createElement(react_final_form_1.Form, { onSubmit: chainAuthErrorMapping_1.chainAuthErrorMapping(onVerifyTOTPSetup) }, function (_a) {
        var handleSubmit = _a.handleSubmit, submitting = _a.submitting, pristine = _a.pristine, hasValidationErrors = _a.hasValidationErrors, submitFailed = _a.submitFailed, dirtySinceLastSubmit = _a.dirtySinceLastSubmit, submitError = _a.submitError;
        return (React.createElement(Components.Wrapper, { header: React.createElement(react_intl_1.FormattedMessage, { id: "COGNITO_AUTH.TOTP_SETUP" }, function (txt) { return React.createElement(Components.Headline, null, txt); }), loading: submitting },
            React.createElement("form", { onSubmit: handleSubmit },
                React.createElement("div", { style: {
                        margin: '2em 0',
                        textAlign: 'center',
                    } },
                    React.createElement(QRCode, { value: additionalData.link, size: 200 })),
                React.createElement(react_intl_1.FormattedMessage, { id: "COGNITO_AUTH.TOTP_SETUP_DESCRIPTION", tagName: "div", values: { secret: React.createElement("pre", null, additionalData.secret) } }),
                React.createElement(react_final_form_1.Field, { autoComplete: "off", name: "code", component: Components.Input, type: "text", placeholder: "COGNITO_AUTH.CODE", label: React.createElement(react_intl_1.FormattedMessage, { id: "COGNITO_AUTH.CODE" }), required: true, validate: Validators_1.Validators.compose(Validators_1.Validators.required, Validators_1.Validators.minLength(6), Validators_1.Validators.maxLength(6)) }),
                React.createElement(Components.ErrorMessage, { message: submitError }),
                React.createElement(Components.Button, { type: "submit", disabled: submitting ||
                        pristine ||
                        hasValidationErrors ||
                        (submitFailed && !dirtySinceLastSubmit) },
                    React.createElement(react_intl_1.FormattedMessage, { id: "COGNITO_AUTH.VERIFY" })))));
    }));
}
exports.TOTPSetup = TOTPSetup;
//# sourceMappingURL=TOTPSetup.js.map